var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.294922 18.3216V16.1358H19.2382V18.3216H0.294922ZM24.9941 16.4272L18.1089 9.54209L24.9577 2.69335L26.5241 4.25982L21.2418 9.54209L26.5605 14.8608L24.9941 16.4272ZM0.294922 10.5985V8.41277H14.8667V10.5985H0.294922ZM0.294922 3.02122V0.835449H19.2382V3.02122H0.294922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e3e8a001429d496221b47da4db366a79.svg";
export { ForwardRef as ReactComponent };